import {
  DashboardComponentNames,
  DashboardLayout,
  DianaFeaturesEnum,
  homePageQuery,
  IDashboardComponentProperties,
  IDashboardDataGridProperties,
  ILayout,
  PageLayout,
  PageNames,
  useCurrentUserStore,
  useHasFeature,
  useSidePeekDrawerProps,
  useWorkVersionDrawer,
} from '@diana/core';
import { useQuery } from '@tanstack/react-query';
import { useBreadcrumbsRoot } from '../../hooks/useBreadcrumbsRoot';

export function HomePage() {
  const breadcrumbRoot = useBreadcrumbsRoot('home');
  const isHomePageAvailable = useHasFeature(DianaFeaturesEnum.HomePage);
  const sidePeekDrawerProps = useSidePeekDrawerProps();
  const ecosystemName = useCurrentUserStore((store) => store.info?.environmentSettings?.name) ?? '';

  useWorkVersionDrawer();

  const { key, fn } = homePageQuery.getLayout({ ecosystemName });
  const { data, isLoading } = useQuery({
    queryKey: key,
    queryFn: fn,
    enabled: isHomePageAvailable,
  });

  if (!isHomePageAvailable) return null;

  return (
    <PageLayout
      name={PageNames.HOME}
      title={breadcrumbRoot.title}
      isContentLoading={isLoading}
      rightDrawer={sidePeekDrawerProps}
    >
      <DashboardLayout
        layout={
          data as unknown as ILayout<
            IDashboardComponentProperties | IDashboardDataGridProperties,
            DashboardComponentNames
          >
        }
      />
    </PageLayout>
  );
}
